var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4933 5.23341L7.03999 9.68675L4.45332 7.10008C4.32841 6.97591 4.15944 6.90622 3.98332 6.90622C3.8072 6.90622 3.63823 6.97591 3.51332 7.10008C3.38915 7.22499 3.31946 7.39395 3.31946 7.57008C3.31946 7.7462 3.38915 7.91517 3.51332 8.04008L6.57332 11.1001C6.69823 11.2242 6.8672 11.2939 7.04332 11.2939C7.21944 11.2939 7.38841 11.2242 7.51332 11.1001L12.4333 6.18008C12.4958 6.1181 12.5454 6.04437 12.5792 5.96313C12.6131 5.88189 12.6305 5.79475 12.6305 5.70675C12.6305 5.61874 12.6131 5.5316 12.5792 5.45036C12.5454 5.36912 12.4958 5.29539 12.4333 5.23341C12.3084 5.10925 12.1394 5.03955 11.9633 5.03955C11.7872 5.03955 11.6182 5.10925 11.4933 5.23341Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckIcon);
export default __webpack_public_path__ + "static/media/white-check-icon.fcd59fd7f45acadbc5b9c89b352e3d9e.svg";
export { ForwardRef as ReactComponent };